import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: null,
};

export const InfoSlice = createSlice({
  name: "info",
  initialState,
  reducers: {
    infoHandler: (state, action) => {

      state.value = action.payload;
    },
    clearInfo: (state) => {
      state.value = null;
    },
  },
});

export const { infoHandler, clearInfo } = InfoSlice.actions;

export default InfoSlice.reducer;
